<template>
    <div :class="'ratioCard-cmp ' + (appColor == 'success' ? 'green' : appColor == 'error' ? 'red' : '')">
        <div class="cbody">
            <p class="mainText">{{ mainText }}<span :class="chip?'chip':''">{{ chip?chip.length ? chip : "":"" }}</span></p>
            <p class="subText">{{ subText }}</p>
        </div>
        <v-icon v-if="tooltip" class="icon tooltip" icon>fa-circle-info</v-icon>
        <div v-if="tooltip" class="tooltip hidden">
            {{ tooltip.text }}
        </div>
    </div>
</template>

<script>
export default {
    name: "RatioCard",
    mounted(){
      
    },
    props: {
        chip: {
            type: String
        },
        mainText: {
            type: String
        },
        subText: {
            type: String
        },
        appColor: {
            type: String
        },
        tooltip: {
            type: Object
        }

    }
}
</script>

<style lang="scss" scoped>
.ratioCard-cmp {
    background-color: transparent !important;
    border-radius: 8px;
    padding: 11px 22px;
    border-left: 4px solid var(--v-mainBlack-base) !important;
    color: var(--v-mainBlack-base);
    position: relative;
    width: calc(20% - 15px);
    margin: 0 0 15px 0px;
    border: 0.5px solid var(--v-mainBlack-base);

    .chip{
        background-color: var(--v-mainBtnBackground-base);
        padding: 2px 8px;
        border-radius: 5px;
        margin-left: 7px;
    }

    &.red {
        border-left: 4px solid var(--v-darkRed-base) !important;
        color: var(--v-darkRed-base) !important;
        border-color: var(--v-darkRed-base) !important;
    }

    &.green {
        border-left: 4px solid var(--v-darkGreen-base) !important;
        color: var(--v-darkGreen-base) !important;
        border-color: var(--v-darkGreen-base) !important;
    }

    .cbody {
        color: inherit;
        display: flex;
        flex-direction: column;

        .mainText {
            display: flex;
            margin: 0;
            margin-right: 5px;
            font-weight: 700;
            color: inherit !important;
        }

        .subText {
            font-size: 16px;
            margin: 0;
            color: inherit !important;
        }

    }

    .icon.tooltip {
        color: inherit;
        position: absolute;
        width: 14px;
        height: 14px;
        bottom: 0;
        right: 0;
    }
}
</style>